import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skf-loader-tiles',
  templateUrl: './skf-loader-tiles.component.html',
  styleUrls: ['./skf-loader-tiles.component.scss']
})
export class SkfLoaderTilesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
